export default __webpack_public_path__ + "static/media/Group 7346.d86d0371.svg";